import { Component, Inject, Type, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogConfirmData {
  title?: string;
  message?: string;
  html?: string;
  messageComponent?: Type<any>;
  hideCancel?: boolean;      // Add this attribute
  okLabel?: string;          // Add this attribute
  
}

@Component({
  selector: 'app-dialog-confirm',
  standalone: false,
  templateUrl: './dialog-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close('ok');
  }
}